
















import { Component, Vue } from 'vue-property-decorator'
import { Dashboard } from '@/api/model/dashboard'
import { DashboardAPI } from '@/api/backend-client'

@Component
export default class Tabs extends Vue {
    dashboards: Dashboard[] = []
    loading: boolean = false
    navArrowLeftVisible: boolean = false
    navArrowRightVisible: boolean = true

    async mounted(): Promise<void> {
        await this.loadDashboards()
        this.$el.addEventListener('scroll', this.onNavScroll)
        this.scrollCurrentIntoView()
    }

    async beforeDestroy(): Promise<void> {
        this.$el.removeEventListener('scroll', this.onNavScroll)
    }

    async loadDashboards(): Promise<void> {
        this.loading = true
        this.dashboards = await DashboardAPI.getAll()
        this.loading = false
    }

    get filteredDashboards(): Dashboard[] {
        return this.dashboards.filter(dashboard => {
            // Check if there is an explicit permission set for this dashboard
            const permission = this.$currentUser.dashboardPermissions.find(v => v.dashboard === dashboard.id)
            if (permission && permission.permission !== null) {
                return permission.permission
            }

            // Otherwise check role
            return this.$currentUser.isBranchManager
        })
    }

    onNavScroll() {
        this.navArrowLeftVisible = this.$el.scrollLeft > 0
        this.navArrowRightVisible = this.$el.scrollLeft < (this.$el.scrollWidth - this.$el.clientWidth)
    }

    scrollCurrentIntoView(): void {
        if (!this.$el.querySelector) {
            return
        }

        this.$el.querySelector('.router-link-exact-active').scrollIntoView({
            behavior: 'smooth',
        })
    }

    scrollLeft(): void {
        this.$el.scrollTo({
            behavior: 'smooth',
            left: this.$el.scrollLeft - this.$el.clientWidth / 4,
        })
    }

    scrollRight(): void {
        this.$el.scrollTo({
            behavior: 'smooth',
            left: this.$el.scrollLeft + this.$el.clientWidth / 4,
        })
    }
}
